export default __webpack_public_path__ + "static/compareItemImg5-0a62f2300f99a9b24db6a7d0ce5b1195.png";